export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de campañas"])},
          "tabs": {
            "summary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen"])},
            "weekly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semanal"])},
            "details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detalles"])}
          }
        }
      },
      "en": {
        
      }
    }
  })
}